import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

const toastOptions = {
  position: "top-center",
  timeout: 3000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: true,
  closeButton: "button",
  icon: true,
  rtl: false
};

const ToastPlugin = {
  install(Vue) {
    Vue.use(Toast, toastOptions);
    
    // Tambahkan helper methods ke Vue prototype
    Vue.prototype.$showSuccess = function(message, options = {}) {
      this.$toast.success(message, options);
    };
    
    Vue.prototype.$showError = function(message, options = {}) {
      this.$toast.error(message, options);
    };
    
    Vue.prototype.$showWarning = function(message, options = {}) {
      this.$toast.warning(message, options);
    };
    
    Vue.prototype.$showInfo = function(message, options = {}) {
      this.$toast.info(message, options);
    };
  }
};

export default ToastPlugin;